// extracted by mini-css-extract-plugin
module.exports = {"dots":"Confetti_dots__AlpkJ","rotation":"Confetti_rotation__266iO"};